export default __webpack_public_path__ + "static/media/fee-grey.0beaa8b6.svg";